import { CurrencyEnum } from '@systemeio/ui'
import { DIGITAL_PRODUCT_API } from 'modules/digital-product/api'
import { DigitalProductSourceEnum } from 'modules/digital-product/enums/digital-product-source-enum'
import { DigitalProductInterface } from 'modules/digital-product/types/digital-product-interface'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { digitalProductDependencies } from '../constants/digital-product-dependencies'

export function useDigitalProductsList(currency: CurrencyEnum, source: DigitalProductSourceEnum) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, DigitalProductInterface[]>({
    method: RequestMethodsEnum.get,
  })

  const { data: digitalProductList, mutate } = useControlledSwr(
    [
      `${DIGITAL_PRODUCT_API}/list?currency=${currency}&source=${source}`,
      ...digitalProductDependencies,
    ],
    fetcher,
    {},
    !!user,
  )

  return { digitalProductList, mutate }
}
